/* eslint-disable react-hooks/exhaustive-deps */
import LoadingTable from 'components/LoadingTable';
import SelectableField from 'components/SelectableField';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import LinkButton from 'components/LinkButton';


function mapStateToProps(state) {
    return { };
}

function ArticlesTableRaw({
    articles = [],
    onDetailSelection = null,
    isLoading,
}) {
    const navigate = useNavigate();

    return (
        <section>
            <LoadingTable isLoading={isLoading}>
                <thead>
                    <tr>
                        <th></th>
                        <th>Article</th>
                        <th>Comments</th>
                        <th>Posted By</th>
                        <th>Tags</th>
                        <th>Status</th>
                        <th>Visibility</th>
                        <th>Action</th>
                    </tr>
                </thead>
                <tbody>
                    {articles.map((article) => (
                        <tr key={`article-${article.id}`}>
                            <td>
                            {article.poster_url && 
                                <SelectableField
                                    url={`/community/articles/${article.id}`}
                                >
                                    <img
                                        src={article.poster_url}
                                        alt={article.name}
                                        style={{
                                            maxHeight: '4rem',
                                            maxWidth: '5rem',
                                            minHeight: '4rem',
                                            minWidth: '5rem',
                                        }}
                                    />
                                </SelectableField>
                            }
                            </td>
                            <td>
                                <SelectableField
                                    action={() => {
                                        if (onDetailSelection) {
                                            onDetailSelection(article);
                                        }
                                        navigate(`/community/articles/${article.id}`);
                                    }}
                                    text={<strong>{article.title}</strong>}
                                />
                            </td>
                            <td>
                                {article.responses_count}
                            </td>
                            <td>
                                <strong>{article.member.name}</strong>
                            </td>
                            <td className="tags">
                                <div className="tagbox">
                                    {article.tags?.map((tag) => (
                                        <div
                                            className="tag"
                                            key={`tag-${article.id}-${tag.id}`}
                                        >
                                            {tag.name}
                                        </div>
                                    ))}
                                </div>
                            </td>
                            <td>
                                <div className='flex flex-col'>
                                {article.is_featured && <span>Featured</span>}
                                {article.is_trending && <span>Trending</span>}
                                {article.is_reel && <span>Reel</span>}
                                </div>
                            </td>
                            <td>
                                <span className='capitalize'>{article.visibility}</span>
                            </td>
                            <td>
                                    <LinkButton
                                        className="table-view-button"
                                        action={() => {
                                        if (onDetailSelection) {
                                            onDetailSelection(article);
                                        }
                                        navigate(`/community/articles/${article.id}`);
                                    }}
                                    >
                                        View
                                    </LinkButton>
                                </td>
                        </tr>
                    ))}
                </tbody>
            </LoadingTable>
        </section>
    );
}

const ArticlesTable = connect(mapStateToProps)(ArticlesTableRaw);
export default ArticlesTable;
